// extracted by mini-css-extract-plugin
export var active = "_c1-7";
export var container = "_c1-0";
export var evenWidth = "_c1-4";
export var large = "_c1-5";
export var outlet = "_c1-8";
export var slide = "_c1-2";
export var small = "_c1-6";
export var tab = "_c1-3";
export var tabs = "_c1-1";